import {Sprite} from 'pixi.js';
import {DrawColor} from './color_picker/DrawColor';
import {ColorButton} from './color_picker/ColorButton';
import {DrawHolderEvent} from '../events/DrawHolderEvent';

export class ColorPicker extends Sprite
{
    private drawButtons: ColorButton[] = [];

    constructor() {
        super();

        this.init();
    }

    private async init(): Promise<void> {
        let between: number = 45;
        let button: ColorButton;
        let colors: DrawColor[] = [DrawColor.BLACK, DrawColor.BLUE, DrawColor.RED, DrawColor.YELLOW, DrawColor.GREEN, DrawColor.CYAN, DrawColor.MAGENTA];
        colors.forEach((drawColor, index) => {
            button = new ColorButton(drawColor, this.onColorClicked.bind(this, drawColor));
            this.drawButtons.push(button);
            this.addChild(button).x = -between * (colors.length - 1) / 2 + index * between;
        });
    }

    public onColorClicked(drawColor: DrawColor): void {
        this.drawButtons.forEach((button, index) => {
            button.selected = button.drawColor == drawColor;
        });
        dispatchEvent(new MessageEvent(DrawHolderEvent.SELECT_COLOR, {data: {drawColor}}));
    }
}
